import {HttpEventType, HttpResponse, HttpUploadProgressEvent} from '@angular/common/http';
import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SubjectApiService, SubjectType, TemplateApiService, TemplateType} from '@npck/af-frontend-api';
import {downloadFromBlobResponse, rxSpinner, Spinner} from '@npck/libs/commons';
import {SnackbarService} from '@npck/libs/ui-kit';
import {NgxDropzoneChangeEvent} from 'ngx-dropzone';
import {Observable} from 'rxjs';
import {ImportExportMode} from '../export-subject-file-dialog/export-subject-file-dialog.component';

@Component({
    templateUrl: 'import-subject-file-dialog.component.html',
    styleUrls: ['import-subject-file-dialog.component.scss'],
    standalone: false
})
export class ImportSubjectFileDialogComponent implements OnInit {
    Spinner = Spinner;
    title: string;
    subtitle: string;
    buttonLabel: string;
    fileData: FileData;
    fileError: 'WRONG_FORMAT';

    constructor(
        @Inject(MAT_DIALOG_DATA) public dialogData: ImportFraudFileDialogData,
        public dialogRef: MatDialogRef<ImportSubjectFileDialogComponent>,
        private subjectApiService: SubjectApiService,
        private templateApiService: TemplateApiService,
        private snackbarService: SnackbarService,
    ) {
    }

    ngOnInit(): void {
        switch (this.dialogData.importMode) {
            case 'subjects':
                this.subtitle = 'i18n_af_importFraudDialogSubtitleUploadFraudSuspectFile';
                break;
        }
    }

    onFileSelected(event: NgxDropzoneChangeEvent): void {
        this.fileError = null;
        if (event.addedFiles.length > 0) {
            const selectedFile = event.addedFiles[0];
            this.fileData = {
                content: new Blob([selectedFile], {type: selectedFile.type}),
                fileName: selectedFile.name,
                progressTotal: selectedFile.size,
                progressLoaded: 0,
                hover: false,
                completed: false,
            };
        } else if (event.rejectedFiles.length > 0) {
            this.fileError = 'WRONG_FORMAT';
        }
    }

    submit(): void {
        let request: Observable<any>;
        switch (this.dialogData.importMode) {
            case 'subjects':
                request = this.subjectApiService.importSubjects(this.dialogData.subjectType, this.fileData.content, 'events', true);
                break;
        }
        request
            .pipe(rxSpinner('saving'))
            .subscribe(event => {
                if (event.type === HttpEventType.UploadProgress) {
                    const uploadEvent = event as HttpUploadProgressEvent;
                    this.fileData.progressTotal = event.total;
                    this.fileData.progressLoaded = uploadEvent.loaded / (uploadEvent.total / 100);
                } else if (event.type === HttpEventType.Response) {
                    this.fileData.progressLoaded = 0;
                    this.fileData.completed = true;
                    this.dialogRef.close();
                    this.snackbarService.showSnackBar('i18n_af_snackBarMessageFileSuccessfullyImported');
                }
            });
    }

    downloadTemplate(): void {
        const request: Observable<HttpResponse<Blob>> =
            this.templateApiService.getReportTemplate(this.dialogData.subjectType as unknown as TemplateType, 'response');
        request.subscribe(response => downloadFromBlobResponse(response));
    }
}

export interface ImportFraudFileDialogData {
    importMode: ImportExportMode;
    subjectType: SubjectType;
}

interface FileData {
    content: Blob;
    hover: boolean;
    fileName: string;
    completed: boolean;
    progressLoaded?: number;
    progressTotal?: number;
}
